import React, { Component} from "react";
import TypeCard from '../TypeCard'

class CarType extends Component{
    render(){
        return(
            <div className="types">
                <h3 className="text-center mb-3">Type de véhicules</h3>
                
                <div className="container row typesCont d-flex justify-content-between ">
                     <div className="col-6 col-md-3 mb-2 mt-2 p-1 p-sm-2">
                        <TypeCard className="typeCard" img ="../../imgs/CarsType/4X4.png" name="4X4" price="à partir de 5000 DZD" typeLink={"location/advanced_search?type=4x4"} />
                     </div>
                     <div className="col-6 col-md-3 mb-2 mt-2 p-1  p-sm-2">
                        <TypeCard className="typeCard " img ="../../imgs/CarsType/citadine.png" name="Citadine" price="à partir de 2000 DZD" typeLink={"location/advanced_search?type=citadine"}/>
                     </div>
                     <div className="col-6 col-md-3 mb-2 mt-2 p-1  p-sm-2">
                        <TypeCard className="typeCard" img ="../../imgs/CarsType/berline.png" name="Berline/Coupé" price="à partir de 3000 DZD" typeLink={"location/advanced_search?type=berline"}/>
                     </div>
                     <div className="col-6 col-md-3 mb-2 mt-2 p-1 p-sm-2">
                        <TypeCard className="typeCard" img ="../../imgs/CarsType/taxi.png" name="Taxi" price="à partir de 500 DZD" typeLink={"location/advanced_search?type=taxi"}/>
                     </div>
                </div>
              
            </div>
        )
    }
}

export default CarType;